<br />
<br />
<div class="fsb-licence limit-width-on-desktop-float">
  <img src="{{ fsbImageUrl }}" class="fsb-img" />
</div>

<!-- TODO ALL OTHER POPUPS SHOULD BE REPLACED BY THIS GENERIC POPUP -->
<popup-dialog  id="fsb.licence.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>
